import React, { useMemo, useRef, useState, useLayoutEffect } from 'react'
import { getColumnType } from '../../../../../utils/columnType'

const ContextMenuOverlay = ({
  contextMenu,
  distributionManager,
  closeContextMenu,
  handleCopyColumn,
  handlePasteColumn,
  handleInsertColumnLeft,
  handleInsertColumnRight,
  handleDeleteColumn,
  handleHideRow,
  handleHideHeaderField,
  handleHideColumn,
  orders,
  selectedItems = [],
  columns = [],
  hasOriginalOrderQuantity,
  onAddPrice,
  onDeletePrice
}) => {
  const overlayRef = useRef(null)
  const [position, setPosition] = useState({ left: 0, top: 0 })

  useLayoutEffect(() => {
    if (!contextMenu.show) return

    const baseLeft = Number(contextMenu.x) || 0
    const baseTop = Number(contextMenu.y) || 0
    let nextLeft = baseLeft
    let nextTop = baseTop

    if (overlayRef.current) {
      const { width, height } = overlayRef.current.getBoundingClientRect()
      const viewportWidth = window.innerWidth
      const viewportHeight = window.innerHeight

      if (nextLeft + width > viewportWidth - 8) {
        nextLeft = Math.max(8, viewportWidth - width - 8)
      }
      if (nextTop + height > viewportHeight - 8) {
        nextTop = Math.max(8, viewportHeight - height - 8)
      }
    }

    setPosition({ left: nextLeft, top: nextTop })
  }, [
    contextMenu.show,
    contextMenu.x,
    contextMenu.y,
    contextMenu.type,
    contextMenu.data
  ])

  const columnType = useMemo(() => {
    if (contextMenu.type !== 'column' || !contextMenu.data?.customerCode)
      return 'deletable'
    return getColumnType(
      contextMenu.data.customerCode,
      orders,
      hasOriginalOrderQuantity
    )
  }, [
    contextMenu.type,
    contextMenu.data?.customerCode,
    orders,
    hasOriginalOrderQuantity
  ])

  if (!contextMenu.show) return null

  const hasRowFirstColMenu =
    contextMenu.type === 'row' && contextMenu.data?.menuType === 'row_first_col'
  const hasHeaderRowMenu = contextMenu.type === 'headerRow'
  const hasColumnMenu = contextMenu.type === 'column'

  if (!hasRowFirstColMenu && !hasHeaderRowMenu && !hasColumnMenu) return null

  const isMultiRow =
    contextMenu.type === 'row' && contextMenu.data?.selectedIndexes?.length > 1
  const isMultiCol =
    contextMenu.type === 'column' && contextMenu.data?.selectedIds?.length > 1

  return (
    <div
      ref={overlayRef}
      className='fixed bg-white border border-gray-300 rounded shadow-lg z-[10000] min-w-[180px]'
      style={{ left: position.left, top: position.top }}
      onClick={(e) => e.stopPropagation()}
    >
      {contextMenu.type === 'row' && (
        <>
          {contextMenu.data.menuType === 'row_first_col' && (
            <>
              <button
                onClick={() => {
                  if (isMultiRow) {
                    const keys = contextMenu.data.selectedIndexes.map((idx) => {
                      const item = selectedItems[idx]
                      return `${item.hinmeiCode}::${item.niukabango}`
                    })
                    handleHideRow(keys)
                  } else {
                    handleHideRow(
                      `${contextMenu.data.item.hinmeiCode}::${contextMenu.data.item.niukabango}`
                    )
                  }
                  closeContextMenu && closeContextMenu()
                }}
                className='w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-gray-100'
              >
                行を非表示
              </button>

              {!isMultiRow && (
                <>
                  <div className='border-t border-gray-200 my-1'></div>

                  {Number(
                    contextMenu.data.item?.total_quantity ??
                      contextMenu.data.item?.quantity ??
                      0
                  ) > 1 && (
                    <button
                      onClick={() => {
                        const priceId =
                          contextMenu.data.priceId ||
                          contextMenu.data.item?.price_groups?.[0]?._priceId
                        onAddPrice && onAddPrice(contextMenu.data.item, priceId)
                        closeContextMenu && closeContextMenu()
                      }}
                      className='w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-gray-100 flex items-center gap-2'
                    >
                      <span>段割れ追加</span>
                    </button>
                  )}

                  {contextMenu.data.item?.price_groups?.length > 1 && (
                    <button
                      onClick={() => {
                        const priceId =
                          contextMenu.data.priceId ||
                          contextMenu.data.item?.price_groups?.[0]?._priceId
                        onDeletePrice &&
                          onDeletePrice(contextMenu.data.item, priceId)
                        closeContextMenu && closeContextMenu()
                      }}
                      className='w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-red-50 text-red-600 flex items-center gap-2'
                    >
                      <span>行を削除</span>
                    </button>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      {contextMenu.type === 'headerRow' && (
        <>
          <button
            onClick={handleHideHeaderField}
            className='w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-gray-100'
          >
            {/* {contextMenu.data?.selectedKeys?.length > 1
              ? `${contextMenu.data.selectedKeys.length}行を非表示`
              : '行を非表示'} */}
            行を非表示
          </button>
        </>
      )}

      {contextMenu.type === 'column' && (
        <>
          {!isMultiCol && (
            <>
              <button
                onClick={handleCopyColumn}
                className='w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-gray-100'
              >
                列をコピー（Ctrl+C）
              </button>

              {distributionManager.clipboardManager.getType() === 'column' && (
                <button
                  onClick={handlePasteColumn}
                  className='w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-gray-100'
                >
                  貼り付け（Ctrl+V）
                </button>
              )}

              <div className='border-t border-gray-200 my-1'></div>
            </>
          )}

          <button
            onClick={() => {
              if (isMultiCol) {
                const keys = contextMenu.data.selectedIds
                  .map((id) => {
                    const col = columns.find((c) => c.id === id)
                    return col ? col.customerCode : null
                  })
                  .filter(Boolean)
                handleHideColumn(keys)
              } else {
                handleHideColumn(contextMenu.data.customerCode)
              }
              closeContextMenu && closeContextMenu()
            }}
            className='w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-gray-100'
          >
            列を非表示
          </button>

          {!isMultiCol && (
            <>
              <div className='border-t border-gray-200 my-1'></div>

              <button
                onClick={handleInsertColumnLeft}
                className='w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-gray-100 flex items-center gap-2'
              >
                <span>左に列を挿入</span>
              </button>

              <button
                onClick={handleInsertColumnRight}
                className='w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-gray-100 flex items-center gap-2'
              >
                <span>右に列を挿入</span>
              </button>

              {columnType === 'deletable' && (
                <>
                  <div className='border-t border-gray-200 my-1'></div>
                  <button
                    onClick={handleDeleteColumn}
                    className='w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-red-50 text-red-600 flex items-center gap-2'
                  >
                    <span>列を削除</span>
                  </button>
                </>
              )}

              <div className='border-t border-gray-200 my-1'></div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default ContextMenuOverlay
